/**
 * Action for Fetch Event List
 */
export enum fetchEventList {
  FETCH__EVENT_LIST_REQUEST = 'FETCH__EVENT_LIST_REQUEST'
}
